import React from 'react';
import forceAppUpdateImg from 'assets/images/force_app_update@2x.png';
import './NewApp.scss';

const NewApp = () => (
    <div className="new-app">
        <div className="new-app__content">
            <div className="new-app__image-wrapper">
                <img
                    className="new-app__image"
                    src={forceAppUpdateImg}
                    alt="Aplikacja w nowej odsłonie"
                />
            </div>
            <div className="new-app__text">
                <h1 className="new-app__title">Zmieniamy się dla Ciebie</h1>
                <div className="new-app__description">
                    <p>
                        Aby móc dalej korzystać z aplikacji i odkryć wszystkie
                        nowości, zaktualizuj ją w sklepie App Store lub Google
                        Play.
                    </p>
                    <p>
                        W razie potrzeby nasz zespół cały czas jest dla Ciebie
                        dostępny - napisz do nas na adres:{' '}
                        <a href="mailto:kontakt@maxxnation.pl">
                            kontakt@maxxnation.pl
                        </a>
                    </p>
                </div>
            </div>
        </div>
    </div>
);

export default NewApp;
